// removed by extract-text-webpack-plugin
module.exports = {"root":"field--root--35gWK6u9","vertical":"field--vertical--3KKRk9RU","horizontal":"field--horizontal--1bFCPZ66 field--vertical--3KKRk9RU","centered":"field--centered--3x0mUlFw","container":"field--container--2-gWUT3T","label":"field--label--1fcGD9K1","help-text":"field--help-text--3LP4XNsj","helpText":"field--help-text--3LP4XNsj"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/field/styles.css
// module id = ./components/forms/field/styles.css
// module chunks = 0